import { TableRow, TableCell, Typography, Box, Button, Checkbox } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { MyAvatar } from 'src/components/common';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import useFormsModalStore from 'src/store/forms';
import { MEDIA_COOPERATION_SCRIPT } from 'src/constants/queryKeys';

// ----------------------------------------------------------------------

export default function MediaCooperationTableRow({ row, rowNumber, selected, onEditRow, onDeleteRow, onCopy }) {
  const { MediaGroupTitle, AffiliatedCompanyName } = row;
  const { enqueueSnackbar } = useSnackbar();

  const [textToCopy, setTextToCopy] = useState('Hello, world!');
  const [copied, setCopied] = useState(false);
  const { setModal, modal } = useFormsModalStore();

  useEffect(() => {
    setTextToCopy(row?.MediaCooperationJsonData);
  }, []);

  return (
    <TableRow hover selected={selected}>
      <TableCell align="left"></TableCell>
      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="left">
        <Typography variant="body1">{AffiliatedCompanyName}</Typography>
      </TableCell>

      <TableCell align="left">
        <Typography variant="body1">{MediaGroupTitle}</Typography>
      </TableCell>

      <TableCell align="right">
        <Box sx={{ display: 'inline-flex', gap: 1 }}>
          <Button
            onClick={() => {
              setModal({
                data: { json: textToCopy, src: 'https://static-content.keylid.com/load.js' },
                isOpen: true,
                type: MEDIA_COOPERATION_SCRIPT,
                title: 'دریافت کد ',
              });
            }}
            size="small"
            color="secondary"
            variant="contained"
          >
            دریافت کد
          </Button>
          <Button size="small" color="info" variant="contained" onClick={onEditRow}>
            ویرایش
          </Button>

          <Button size="small" color="error" variant="contained" onClick={onDeleteRow}>
            حذف
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
}
